module.exports = __webpack_public_path__ + "static/no-obligation-e6636cc3a230155f992d61cdb1a981f6.svg";